export function shouldRedirectAuthFailure(
  { pathname, searchParams }: Location & { searchParams: URLSearchParams },
) {
  if (searchParams.has('redirectUri')) return false;
  if (!pathname.startsWith('/w/')) return false;

  return true;
}
